import { useTranslation } from 'react-i18next';
import { CalendarDays, List } from 'lucide-react';

export type BrowseView = 'list' | 'calendar';

/** List ↔ calendar segmented control. Shared by the Appointments, Calls and
 *  specialist dashboards so the toggle looks and behaves identically. */
export function ViewToggle({
  view,
  onChange,
}: {
  view: BrowseView;
  onChange: (view: BrowseView) => void;
}) {
  const { t } = useTranslation();
  return (
    <div
      role="group"
      className="inline-flex shrink-0 items-center gap-0.5 rounded-lg border border-border bg-muted/40 p-0.5"
    >
      {(['list', 'calendar'] as const).map((v) => {
        const Icon = v === 'list' ? List : CalendarDays;
        const active = view === v;
        return (
          <button
            key={v}
            type="button"
            aria-pressed={active}
            aria-label={t(v === 'list' ? 'appointments.viewList' : 'appointments.viewCalendar')}
            onClick={() => onChange(v)}
            className={`inline-flex h-8 w-8 items-center justify-center rounded transition-colors ${
              active ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon className="h-4 w-4" />
          </button>
        );
      })}
    </div>
  );
}
